<template>
    <div id="layout">
      <AppSidebar />
      <div class="main-content">
        <TopNavBar />
        <div class="content">
          <router-view />
        </div>
      </div>
    </div>
  </template>


  <script>
  import AppSidebar from '@/components/AppSidebar.vue';
  import TopNavBar from '@/components/TopNavBar.vue';

  export default {
    name: 'DefaultLayout',
    components: {
      AppSidebar,
      TopNavBar
    }
  };
  </script>

  <style scoped>
  #layout {
    display: flex;
    height: 100vh; /* Заполнение всей высоты окна */
    overflow: hidden;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: auto; /* Чтобы основной контент мог прокручиваться */
  }

  .content {
    margin-left: 0; /* Убираем наложение */
    padding: 20px;
    width: 100%;
    flex: 1; /* Заполнение доступного пространства */
  }
  </style>
